<template>
    <span class="exp-span-text">{{expSpan}}</span>
</template>

<script setup>
    import eshopopeeApi from "@/request/eshopopeeApi"
    import { useUserinfo } from '@/stores/userinfo'
    import {toRef, ref, onMounted, inject} from "vue";

    const userInfoRef = toRef(useUserinfo())

    const { getShopCompanyObj } = inject('shopControlFunc', { getShopCompanyObj: () => { return null } })
    const shopCompany = ref(null)

    const expSpan = ref("")

    function getExpSpan() {
        const request = eshopopeeApi.getCompanyEndDates
        const params = request.getParams()

        if (null == shopCompany.value){
            params.CompanyCodes = userInfoRef.value.acccompanycode
        }else{
            params.CompanyCodes = shopCompany.value.acccompanycode
        }

        request.send(params, (res) => {
            if (null != res && res.length > 0){
                expSpan.value = res[0].onLineEndDate
            }
        })
    }

    onMounted(() => {
        shopCompany.value = getShopCompanyObj()
        getExpSpan()
    })
</script>

<style scoped>
    .exp-span-text {
        font-weight: 600;
        color: #409EFF;
    }
</style>